const name = 'scansheets';

export const GET_SCANSHEET_ORDERS_LIST_REQUEST = `${name}/GET_SCANSHEET_ORDERS_LIST_REQUEST`;
export const GET_SCANSHEET_ORDERS_LIST_SUCCESS = `${name}/GET_SCANSHEET_ORDERS_LIST_SUCCESS`;
export const GET_SCANSHEET_ORDERS_LIST_FAILURE = `${name}/GET_SCANSHEET_ORDERS_LIST_FAILURE`;

export const GET_SCANSHEET_ORDERS_TABLE_CONFIGURATION_REQUEST = `${name}/GET_SCANSHEET_ORDERS_TABLE_CONFIGURATION_REQUEST`;
export const GET_SCANSHEET_ORDERS_TABLE_CONFIGURATION_SUCCESS = `${name}/GET_SCANSHEET_ORDERS_TABLE_CONFIGURATION_SUCCESS`;
export const GET_SCANSHEET_ORDERS_TABLE_CONFIGURATION_FAILURE = `${name}/GET_SCANSHEET_ORDERS_TABLE_CONFIGURATION_FAILURE`;

export const GET_SCANSHEET_PRODUCTS_LIST_REQUEST = `${name}/GET_SCANSHEET_PRODUCTS_LIST_REQUEST`;
export const GET_SCANSHEET_PRODUCTS_LIST_SUCCESS = `${name}/GET_SCANSHEET_PRODUCTS_LIST_SUCCESS`;
export const GET_SCANSHEET_PRODUCTS_LIST_FAILURE = `${name}/GET_SCANSHEET_PRODUCTS_LIST_FAILURE`;

export const GET_SCANSHEET_PRODUCTS_TABLE_CONFIGURATION_REQUEST = `${name}/GET_SCANSHEET_PRODUCTS_TABLE_CONFIGURATION_REQUEST`;
export const GET_SCANSHEET_PRODUCTS_TABLE_CONFIGURATION_SUCCESS = `${name}/GET_SCANSHEET_PRODUCTS_TABLE_CONFIGURATION_SUCCESS`;
export const GET_SCANSHEET_PRODUCTS_TABLE_CONFIGURATION_FAILURE = `${name}/GET_SCANSHEET_PRODUCTS_TABLE_CONFIGURATION_FAILURE`;

export const UPDATE_SCANSHEET_PRODUCTS_PRIO_SUPPLIER_REQUEST = `${name}/UPDATE_SCANSHEET_PRODUCTS_PRIO_SUPPLIER_REQUEST`;
export const UPDATE_SCANSHEET_PRODUCTS_PRIO_SUPPLIER_SUCCESS = `${name}/UPDATE_SCANSHEET_PRODUCTS_PRIO_SUPPLIER_SUCCESS`;
export const UPDATE_SCANSHEET_PRODUCTS_PRIO_SUPPLIER_FAILURE = `${name}/UPDATE_SCANSHEET_PRODUCTS_PRIO_SUPPLIER_FAILURE`;

export const ADD_SCANSHEET_PRODUCTS_PACKING_REQUEST = `${name}/ADD_SCANSHEET_PRODUCTS_PACKING_REQUEST`;
export const ADD_SCANSHEET_PRODUCTS_PACKING_SUCCESS = `${name}/ADD_SCANSHEET_PRODUCTS_PACKING_SUCCESS`;
export const ADD_SCANSHEET_PRODUCTS_PACKING_FAILURE = `${name}/ADD_SCANSHEET_PRODUCTS_PACKING_FAILURE`;

export const SET_SCANSHEET_PRODUCT_UNAVAILABLE_REQUEST = `${name}/SET_SCANSHEET_PRODUCT_UNAVAILABLE_REQUEST`;
export const SET_SCANSHEET_PRODUCT_UNAVAILABLE_SUCCESS = `${name}/SET_SCANSHEET_PRODUCT_UNAVAILABLE_SUCCESS`;
export const SET_SCANSHEET_PRODUCT_UNAVAILABLE_FAILURE = `${name}/SET_SCANSHEET_PRODUCT_UNAVAILABLE_FAILURE`;

export default name;
